import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
type OverrideIconSize = OverrideIconSize20;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="7.5" stroke={color} />
        <path
          d="M9.34285 11.8956C9.34285 11.2583 9.42241 10.7416 9.58811 10.352C9.7624 9.95193 10.076 9.59783 10.5191 9.28909C10.8787 9.02595 11.1293 8.79208 11.2777 8.58795L11.279 8.58622C11.4294 8.38799 11.5045 8.16219 11.5045 7.9049C11.5045 7.52692 11.3751 7.23154 11.1186 7.00811L11.1176 7.00728C10.8674 6.78391 10.5136 6.66569 10.0428 6.66569C9.72179 6.66569 9.44886 6.7357 9.22023 6.87163C8.99462 7.00985 8.82269 7.18589 8.70181 7.39966C8.58565 7.61728 8.52174 7.84334 8.50892 8.07875C8.50589 8.13439 8.45989 8.17795 8.40418 8.17795H7.35835C7.29905 8.17795 7.2515 8.12892 7.25332 8.06965C7.26759 7.6036 7.39276 7.17275 7.62864 6.77896C7.86499 6.38438 8.19099 6.07409 8.60439 5.84861C9.02596 5.61539 9.50286 5.5 10.0325 5.5C10.5867 5.5 11.0697 5.6037 11.4781 5.81547C11.8916 6.01932 12.2092 6.30532 12.4263 6.67425C12.6428 7.03529 12.75 7.44657 12.75 7.9049C12.75 8.67715 12.3438 9.34622 11.5642 9.91228L11.5621 9.91382C11.2732 10.1126 11.0602 10.3112 10.9184 10.5084C10.7747 10.7084 10.6782 10.9127 10.6268 11.1214C10.581 11.3357 10.5575 11.5934 10.5575 11.8956C10.5575 11.9536 10.5105 12.0006 10.4525 12.0006H9.44787C9.38987 12.0006 9.34285 11.9536 9.34285 11.8956Z"
          fill={color}
        />
        <path
          d="M9.36186 14.2373C9.19809 14.0698 9.11639 13.861 9.11639 13.6179C9.11639 13.3743 9.19837 13.1652 9.3627 12.9975C9.52704 12.8298 9.73205 12.7462 9.97075 12.7462C10.209 12.7462 10.4138 12.8296 10.578 12.9966C10.7491 13.1638 10.8354 13.3732 10.8354 13.6179C10.8354 13.8674 10.7541 14.0804 10.5891 14.2487C10.4241 14.417 10.2153 14.5 9.97075 14.5C9.73091 14.5 9.52568 14.412 9.36186 14.2373Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'question');
export default IconComponent;
